import React from 'react';
import { classNames } from '../utils';

export default function Button({
  children,
  variant = 'base',
  className,
  ...props
}) {
  return (
    <button
      type="button"
      className={classNames(
        variant === 'medium'
          ? `px-2 py-1`
          : variant === 'small'
          ? `px-2`
          : `px-3 py-1`,
        'relative inline-flex items-center border border-gray-500 hover:border-gray-300 text-lg font-medium rounded-md text-gray-300 bg-gray-800 ',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
